import { render, staticRenderFns } from "./BatteryFaultCount.vue?vue&type=template&id=12f53894&scoped=true"
import script from "./BatteryFaultCount.vue?vue&type=script&lang=js"
export * from "./BatteryFaultCount.vue?vue&type=script&lang=js"
import style0 from "./BatteryFaultCount.vue?vue&type=style&index=0&id=12f53894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f53894",
  null
  
)

export default component.exports